import * as yup from "yup";

export const OFFICE_NOTE_EDIT_FORM_SCHEMA = yup.object().shape({
  content: yup.string().required("Molimo Vas da unesete bilješku"),
});
